document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".mobile-facets_filter");
  const accordionsDetails = document.querySelectorAll("#FacetFiltersFormMobile details");
  if (window.innerWidth > 768) {
  accordionsDetails.forEach((details) => {
    details.open = true;
  })
    }
  accordions.forEach((accordion) => {
    accordion.addEventListener("toggle", function () {
      if (this.open) {
        accordions.forEach((other) => {
          if (other !== this) other.open = false;
        });
      }
    });
  });
});
